import styled from 'styled-components';
import { color } from 'styles/colors';

export const container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  > p {
    color: ${color.interface.lightGray};
    font-size: 1.1rem;
    text-align: center;
  }
`;

export const defaultType = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  > p {
    color: ${color.interface.darkgray};
    font-size: 1rem;
    text-align: center;
  }

  > b {
    color: ${color.interface.greenSuperXtra};
    font-weight: 300;
    font-size: 1rem;
  }
`;

export const imageType = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  > p {
    color: ${color.interface.darkgray};
    font-size: 1rem;
    text-align: center;
  }

  > svg {
    color: ${color.interface.greenSuperXtra};
    font-size: 15px;
  }

  > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    gap: 10px;
    > img {
      width: 20px;
      height: 20px;
      object-fit: fill;
    }
  }
`;

export const searchType = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  > p {
    color: ${color.interface.darkgray};
    font-size: 1rem;
    text-align: center;
    font-weight: 200;
  }

  > img {
    width: 20px;
    height: 20px;
    object-fit: fill;
  }
`;
